/**
 * @generated SignedSource<<10b447c93ce3549e32d79726e2785b2c>>
 * @relayHash c3c4780dd7e2e6b367d11269db99d881
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e77ad542f01a5ddf3af569573494b867068328384e180e3e18dc3ced0d4d5ea1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiJiraSoftwareEditSprintModalQuery } from './uiJiraSoftwareEditSprintModalQuery.graphql';

const node: PreloadableConcreteRequest<uiJiraSoftwareEditSprintModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e77ad542f01a5ddf3af569573494b867068328384e180e3e18dc3ced0d4d5ea1",
    "metadata": {},
    "name": "uiJiraSoftwareEditSprintModalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
